export default "__VITE_ASSET__7031e0d3__"